import { Box, BoxProps } from '@chakra-ui/react';

export const Paragraph = (props: BoxProps) => <Box as="p" mb="2" fontSize={['sm', 'md']} {...props} />;
